import angular from 'angular';
import uiRouter from 'angular-ui-router';
import advertFeaturePageComponent from './advertFeaturePage.component';

let advertFeaturePageModule = angular.module('advertFeaturePage', [
  uiRouter
])

.component('advertFeaturePage', advertFeaturePageComponent)

.name;

export default advertFeaturePageModule;
